import { routes } from '@shared/api/routes';

import type { ICommentMessage } from '@entities/message';

export const taskCommentsApiRoutes = {
    getTaskCommentsRoute: (taskId: string) =>
        routes.getCustomTaskComments({ _customTask_: taskId }),
    pollTaskCommentsRoute: (taskId: string) =>
        routes.pollCustomTaskComments({ _customTask_: taskId }),
    createTaskCommentRoute: (taskId: string) =>
        routes.createCustomTaskComment({ _customTask_: taskId }),
    deleteTaskCommentRoute: (taskId: string, commentId: ICommentMessage['id']) =>
        routes.deleteCustomTaskComment({ _customTask_: taskId, _comment_: commentId }),
};
